var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit, invalid, pristine }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", "data-testid": "affiliateForm" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PUBLISHER_COMPANY"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PUBLISHER_COMPANY_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "name",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentPublisher
                                                            .name,
                                                        expression:
                                                          "currentPublisher.name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "PUBLISHER_COMPANY_DEFAULT"
                                                      ),
                                                      type: "text",
                                                      name: "name",
                                                      autocomplete: "off",
                                                      "custom-autofocus":
                                                        "true",
                                                      "data-testid":
                                                        "affiliateFormName"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentPublisher
                                                          .name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.currentPublisher,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PUBLISHER_SUBID"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PUBLISHER_SUBID_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "subId",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentPublisher
                                                            .subId,
                                                        expression:
                                                          "currentPublisher.subId"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "PUBLISHER_SUBID_DEFAULT"
                                                      ),
                                                      name: "subId",
                                                      autocomplete: "off",
                                                      "data-testid":
                                                        "affiliateFormSubId"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentPublisher
                                                          .subId
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.currentPublisher,
                                                          "subId",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("PUBLISHER_NUMBER_CREATION"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("PUBLISHER_NUMBER_CREATION_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "createNumbers",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c("NzToggle", {
                                                    attrs: {
                                                      name: "createNumbers"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentPublisher
                                                          .createNumbers,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentPublisher,
                                                          "createNumbers",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentPublisher.createNumbers"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      staticClass: "m-b-5",
                      attrs: {
                        label: _vm.$t(
                          "ACCOUNT_SETTINGS_PUBLISHER_BLOCK_CALLS_ON_CAP"
                        ),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "PUBLISHER_ACCEPT_CALLS_ON_CAP_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "settingToggleBlockCallsIfCapped",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ol-sm-9 col-md-9"
                                                },
                                                [
                                                  _c("MultipleToggleOverride", {
                                                    attrs: {
                                                      "toggle-name":
                                                        "settingToggleBlockCallsIfCapped",
                                                      value:
                                                        _vm.currentPublisher
                                                          .blockCallsIfCapped,
                                                      options:
                                                        _vm.blockCallsIfCappedOptions,
                                                      disabled: false
                                                    },
                                                    on: {
                                                      onToggle:
                                                        _vm.toggleBlockCallsOnPubCapValueChanged
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      staticClass: "m-b-5",
                      attrs: {
                        label: _vm.$t("PUBLISHER_ACCESS_TO_RECORDINGS"),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "PUBLISHER_ACCESS_TO_RECORDINGS_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "rpcSetting",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ol-sm-9 col-md-9"
                                                },
                                                [
                                                  _c("MultipleToggleOverride", {
                                                    attrs: {
                                                      "toggle-name":
                                                        "settingToggleAccessToRecordings",
                                                      value:
                                                        _vm.currentPublisher
                                                          .accessToRecordings,
                                                      options:
                                                        _vm.publisherAccessToRecordingOptions,
                                                      disabled: false
                                                    },
                                                    on: {
                                                      onToggle:
                                                        _vm.toggleBlockAccessToRecordingsValueChanged
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        attrs: { "data-testid": "submit-wrapper" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                          },
                          [
                            invalid && _vm.triedToSend
                              ? _c(
                                  "p",
                                  { staticClass: "m-t-8 m-b-8 bright-red" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "f-s-20 p-r-0 typcn typcn-warning"
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.$t("INVALID_FORM")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "PrimaryButton",
                              {
                                attrs: {
                                  size: "sm",
                                  "show-loader-on-form": _vm.showLoader,
                                  "data-testid": "submit"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.triedToSend = true
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: _vm.currentPublisher.id
                                        ? "UPDATE"
                                        : "CREATE",
                                      expression:
                                        "currentPublisher.id ? 'UPDATE' : 'CREATE'"
                                    }
                                  ]
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "CANCEL",
                                  expression: "'CANCEL'"
                                }
                              ],
                              staticClass: "btn btn-sm btn-danger m-l-15",
                              attrs: { "data-testid": "cancel" },
                              on: { click: _vm.cancel }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }